export default "https://cdn-static.gokick.com/assets/33ce344a4b715ce65918e7685bcdda5ecb423fac/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";